module.exports = __webpack_public_path__ + "media/images/web/landings/teachers/s1-1a390a8faf54098fa2808ccdf07b86a3.jpg";